import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from './SafeIcon';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navLinks = [
    { name: 'Alerts & Recalls', path: '/alerts' },
    { name: 'Product Database', path: '/products' },
    { name: 'Resources', path: '/resources' },
    { name: 'About', path: '/about' },
  ];

  return (
    <header className="bg-white border-b border-gray-200 sticky top-0 z-50">
      {/* Top Bar */}
      <div className="bg-primary text-white text-xs py-1 px-4">
        <div className="container-custom flex justify-between items-center">
          <span>Trusted Independent Safety Reporting</span>
          <div className="flex gap-4">
            <span className="hover:underline cursor-pointer">Subscribe to Alerts</span>
            <span className="hover:underline cursor-pointer">Report an Issue</span>
          </div>
        </div>
      </div>

      {/* Main Header */}
      <div className="container-custom py-4">
        <div className="flex justify-between items-center">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2 group">
            <div className="bg-primary text-white p-2 rounded-lg group-hover:bg-primary-light transition-colors">
              <SafeIcon icon={FiIcons.FiShield} className="text-2xl" />
            </div>
            <div className="flex flex-col">
              <h1 className="text-2xl font-bold text-primary leading-none tracking-tight">Moringa</h1>
              <span className="text-xs uppercase tracking-widest text-accent font-semibold">Safety Report</span>
            </div>
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <NavLink
                key={link.name}
                to={link.path}
                className={({ isActive }) =>
                  `text-sm font-medium transition-colors hover:text-primary ${
                    isActive ? 'text-primary font-bold' : 'text-gray-600'
                  }`
                }
              >
                {link.name}
              </NavLink>
            ))}
            <button className="text-gray-500 hover:text-primary">
              <SafeIcon icon={FiIcons.FiSearch} className="text-xl" />
            </button>
          </nav>

          {/* Mobile Menu Button */}
          <button 
            className="md:hidden text-gray-700"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <SafeIcon icon={isMenuOpen ? FiIcons.FiX : FiIcons.FiMenu} className="text-2xl" />
          </button>
        </div>
      </div>

      {/* Mobile Nav */}
      {isMenuOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 py-4 px-4 shadow-lg">
          <nav className="flex flex-col gap-4">
            {navLinks.map((link) => (
              <Link
                key={link.name}
                to={link.path}
                className="text-gray-700 font-medium py-2 border-b border-gray-50 last:border-0"
                onClick={() => setIsMenuOpen(false)}
              >
                {link.name}
              </Link>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;